import React from 'react'
import Icon from './Icon'

export default function Hamburger(props) {
  return (
    <button
      className={`close d-block d-lg-none m-3 ease ${
        props.slide ? 'slided' : ''
      }`}
      type='button'
      onClick={props.handleSlide}
    >
      <Icon name='menu' />
    </button>
  )
}
